export enum TipoAcao{
  ENCERRAR_SESSAO = "Encerrar Sessão",
  ENCERRAR_ATENDIMENTO = "Encerrar Atendimento"
}
